/** @module Camunda/TaskCommentRenderer */
define([
	"dojo/_base/declare",
	"csi/heading/String",
	"csi/html",
	"csi/locale",
	"csi/widget/MaterialIconWithLabel"
], function(declare,StringRen,html,locale,MaterialIconWithLabel) {

	return declare(StringRen, {
		/**
		 * @override
		 * Render the content with the material icon
		 */
		toHtmlStatic: function(ctx, h, refNode, actionData) {
			new MaterialIconWithLabel({
				className: "csi-link-btn",
				icon: "comment",
				label: locale.resource("CommentPlaceHolder")
			}).placeAt(refNode);

			return true;
		},

		/**
		 * @override
		 * Show tooltip when hovering over the content
		 */
		toTooltip: function(ctx, h, tooltip) {
			const node = ctx.getNode();
			const comments = node.Comments;

			if (comments) {
				const div = html.create("div", {"class": html.CSS_RICH_TEXT});
				html.richText(comments, div);
				tooltip.addContent(div);
			}
		}
	});
});
